import Joi from 'joi';

const ReviewAction = Joi.string().allow('');

export default ReviewAction;
